module.exports={
    record: {
        search:'搜索',
        sure:'确定',
        expList:"导出",
        expHint:{
            errorMsg:"记录导出失败，请重试",
            successMsg:"记录导出成功",
        },
        table:{
        	index:'序号',
        	mac:'标签Mac地址',
        	commodity:'ID',
        	updateTime:'更新时间',
        	type:'操作类型',
        	result:'操作结果',
        	operator:'操作人',
            // updateLabel:'更新标签',
            // updateLabel1:'更新标签',
            // upgradeESL:'升级标签',
            // upgradeESL1:'升级标签',
            // updateSucceeded:'更新成功',
            // updateSucceeded1:'更新成功',
            // updateFailed:'更新失败',
            // updateFailed1:'更新失败',
            // upgradeESLSucceeded:'升级成功',
            // upgradeESLSucceeded1:'升级成功',
            // upgradeESLFailed:'升级失败',
            // upgradeESLFailed1:'升级失败'

        },
        hintMsg:{
            queryRecordFail:'查询日志记录失败'
        },
        // operation:[{
        //     name:'Update ESL',
        //     value:'更新标签'
        // },{
        //     name:'Update succeeded',
        //     value:'更新成功'
        // },{
        //     name:'Update failed',
        //     value:'更新失败'
        // }],


        operationType:[{  //操作类型
            value:'',
            label:'全部操作类型'
        },{
            value:'1',
            label:'更新标签'
        },{
            value:'2',
            label:'升级标签'
        }],
        operationResult:[{   //操作结果
            result:[{
                value:'',
                label:'全部操作结果'
            }]
        },{
            result:[{        //更新标签
                value:'1',
                label:'更新成功'
            },{
                value:'2',
                label:'更新失败'
            },{
                value:'3',
                label:'标签秘钥错误'
            },{
                value:'7',
                label:'更新超时'
            },{
                value:'9',
                label:'屏幕损坏'
            },{
                value:'10',
                label:'网关离线'
            },{
                value:'11',
                label:'模板错误或不存在'
            },{
                value:'12',
                label:'网关硬件异常'
            },{
                value:'13',
                label:'固件和屏幕不一致'
            }]
        },
        {
            result:[{   //升级标签
                value:'3',
                label:'标签秘钥错误'
            },{        
                value:'4',
                label:'升级成功'
            },{
                value:'5',
                label:'升级失败'
            },{
                value:'6',
                label:'升级包出错'
            },{
                value:'8',
                label:'升级超时'
            },{
                value:'10',
                label:'网关离线'
            },{
                value:'12',
                label:'网关硬件异常'
            }]
        }],
        typeAndResult:[{  //操作类型和操作结果映射关系,按顺序获取
            key:'',
            value:0
        },{
            key:'1',
            value:1
        },{
            key:'2',
            value:2
        }],
        type:{
            // resultAll:'全部操作结果'
            // operationTypeMsg:'请选择操作类型',
            // operationResultMsg:'请选择操作结果'
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/record.js